"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _patient = require('shared/validation/patient');

var _typedFormat = require('./typedFormat');

/* What's wrong with a new patient, per field; Contact when there's neither a
 * phone nor an email. */


const FIELD_OF = {
  firstName: 'FirstName', lastName: 'LastName', dob: 'DOB', email: 'Email', phone: 'Phone', foreignID: 'MRN',
}

/* Review R800-6: the Directory's patient form rules (contactPhone,
 * contactEmail, a phone or an email), so a malformed contact is caught in
 * the dialog instead of on the list's row after it closes. */
 const newPatientProblems = (f, { isNameRequired = false } = {}) => {
  const { error } = _patient.patientSchema.validate(
    {
      firstName: f.FirstName.trim(), lastName: f.LastName.trim(), dob: f.DOB.trim(),
      email: f.Email.trim(), phone: f.Phone.trim(), foreignID: f.MRN.trim(),
    },
    { abortEarly: false },
  )
  const problems = {}
  for (const d of _nullishCoalesce(_optionalChain([error, 'optionalAccess', _ => _.details]), () => ( []))) {
    const field = FIELD_OF[String(d.path[0])]
    if (field) problems[field] ??= d.message
    else if (d.type === 'object.missing') problems.Contact = 'Add a phone or email'
  }
  // Rev 23 B2: a date the server can read, and a real one.
  const dob = _typedFormat.dobProblem.call(void 0, f.DOB.trim())
  if (dob) problems.DOB ??= dob
  // A patient created on their own (the picker's New patient, D-84) needs a
  // name to be found in the list; a recipient row is named by its contact.
  if (isNameRequired && !f.FirstName.trim() && !f.LastName.trim()) problems.FirstName ??= 'Add a first or last name'
  return problems
}; exports.newPatientProblems = newPatientProblems
